import { useContext } from "react";
import { context } from "../util/providers/CustomerProvider";

export const useCustomerObjectMap = () => {
  const { customers, refetch , loading } = useContext(context);
  return { customers, refetch, loading };
};